export const NEXT_STEP = "NEXT_STEP";
export const ADD_STEPS = "ADD_STEPS";
export const DOUBLE_TRAITOR = "DOUBLE_TRAITOR";

